import { Keys } from '../types';

const keys: Keys = {
  alchemy: 'trix72l2oM0eJK0UB8YfR',
};

export default keys;
